/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.klaviyo-bis-trigger').forEach(function (button) {
    button.addEventListener('click', function () {
      const variantId = button.getAttribute('data-variant-id');
      const productId = button.getAttribute('data-product-id');
      const productName = button.getAttribute('data-product-name');
      const productUrl = button.getAttribute('data-product-url');

      if (window._klOnsite) {
        window._klOnsite.push(["openBackInStockModal", {
          variantId: variantId,
          productId: productId,
          productName: productName,
          productUrl: productUrl
        }]);
      } else {
        console.error('Klaviyo not initialized yet');
      }
    });
  });
});




window.addEventListener('DOMContentLoaded', function () {
  if (window.location.search.includes('notifyme=true')) {
    setTimeout(function () {
      document.querySelector('a.klaviyo-bis-trigger')?.click();
    }, 200);
  }
});



  
  // Add custom code below this line

  $(document).ready(function () {
  $('.full_clickable').each(function () {
    const $container = $(this);
    const $link = $container.find('a').first();

    if ($link.length && $link.attr('href')) {
      $container.css('cursor', 'pointer');

      $container.on('click', function (e) {
        // Prevent redirect if actual <a> is clicked
        if (!$(e.target).closest('a').is($link)) {
          window.location.href = $link.attr('href');
        }
      });
    }
  });
});
  

$(document).ready(function () {
    const seenCurrencies = new Set();

    $(".header__desktop__buttons.header__desktop__buttons--icons.caps ul.popout-list li.popout-list__item").each(function () {
        const currencyText = $(this).find("span").text().trim(); // Get the text inside <span>
        if (seenCurrencies.has(currencyText)) {
            $(this).remove(); // Remove the <li> if the currency is already seen
        } else {
            seenCurrencies.add(currencyText); // Add currency to the set
        }
    });
});

   const seenCurrencies2 = new Set();

    $(".drawer__bottom.mobile li.popout-list__item").each(function () {
        const currencyText2 = $(this).find("span").text().trim(); // Get the text inside <span>
        if (seenCurrencies2.has(currencyText2)) {
            $(this).remove(); // Remove the <li> if the currency is already seen
        } else {
            seenCurrencies2.add(currencyText2); // Add currency to the set
        }
    });






  

function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  const schart = document.querySelector(".size-guide-popup");
  const schartBtn = document.querySelector("#size_guide_open");
  const schartClose = document.querySelector("#size_guide_close");
  
  if (schart && schartBtn) {
      schartBtn.addEventListener("click", (event) => {
          event.preventDefault();
          schart.classList.add("open");
      });
  }
  
  if (schart && schartClose) {
      schartClose.addEventListener("click", (event) => {
          event.preventDefault();
          schart.classList.remove("open");
      });
  }
  
  // Function to close the popup if clicked outside
  if (schart) {
      document.addEventListener("click", (event) => {
          if (schart.classList.contains("open") && !schart.contains(event.target) && event.target !== schartBtn) {
              schart.classList.remove("open");
          }
      });
  }

  

  function toggleStores() {
    // Select all elements with the class "link-stores" and add a click event listener
    document.querySelectorAll('.link-stores').forEach(function (element) {
      element.addEventListener('click', function () {
        var id = this.getAttribute('id');
        console.log("Id: ", id);
  
        if (id === 'ALL') {
          // If the id is "ALL", add the class "open-stores" to all elements with the class "stores_wrapper"
          document.querySelectorAll('.stores_wrapper').forEach(function (wrapper) {
            wrapper.classList.add('open-stores');
          });
        } else {
          // Remove the class "open-stores" from all elements with the class "stores_wrapper" except the current one
          document.querySelectorAll('.stores_wrapper').forEach(function (wrapper) {
            if (wrapper !== this) {
              wrapper.classList.remove('open-stores');
            }
          });
  
          // Toggle the class "open-stores" on the current element and remove the class from its siblings
          var currentWrapper = document.querySelector('.stores--wrapper #' + id);
          if (currentWrapper) {
            currentWrapper.classList.toggle('open-stores');
            currentWrapper.parentNode.querySelectorAll('.stores_wrapper').forEach(function (sibling) {
              if (sibling !== currentWrapper) {
                sibling.classList.remove('open-stores');
              }
            });
          }
        }
  
        // Add the class "light_grey" to the clicked element and remove it from its siblings
        this.classList.add('light_grey');
        this.parentNode.querySelectorAll('.link-stores').forEach(function (sibling) {
          if (sibling !== this) {
            sibling.classList.remove('light_grey');
          }
        }.bind(this));
      });
    });
  
    // Mobile functionality
    document.querySelectorAll('.mobile--stores').forEach(function (element) {
      element.addEventListener('click', function () {
       
        document.querySelectorAll('.mobile--stores').forEach(function (mobileStore) {
          mobileStore.classList.toggle('border--no');
        });
  
        // Toggle visibility of siblings
        var siblings = this.parentNode.children;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== this) {
            siblings[i].style.display = siblings[i].style.display === 'none' ? '' : 'none';
          }
        }
      });
    });
  }

  var Collapsible = (function () {
    function Collapsible() {
      this._attachListeners();
    }
  
    Collapsible.prototype._attachListeners = function () {
      // Add click event listener to elements with data-action="toggle-collapsible"
      document.body.addEventListener('click', (event) => {
        if (event.target.matches('[data-action="toggle-collapsible"]')) {
          this._toggleCollapsible(event);
        }
      });
    };
  
    /**
     * Toggle a given collapsible
     */
    Collapsible.prototype._toggleCollapsible = function (event) {
      var target = event.target;
      var parentCollapsible = target.closest('.Collapsible');
  
      if (parentCollapsible.classList.contains('Collapsible--autoExpand') && matchBreakpoint('tablet-and-up')) {
        return;
      }
  
      var isOpen = target.getAttribute('aria-expanded') === 'true';
  
      if (isOpen) {
        this._close(parentCollapsible, target);
      } else {
        this._open(parentCollapsible, target);
      }
  
      // Close siblings' collapsibles
      var siblings = Array.from(parentCollapsible.parentNode.children).filter(function (sibling) {
        return sibling !== parentCollapsible && sibling.classList.contains('Collapsible');
      });
  
      siblings.forEach((sibling) => {
        this._close(sibling);
      });
  
      event.preventDefault();
    };
  
    /**
     * Open a given collapsible
     */
    Collapsible.prototype._open = function (collapsible) {
      var toggleButton = collapsible.querySelector('.Collapsible__Button');
      var collapsibleInner = collapsible.querySelector('.Collapsible__Inner');
  
      if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
        return; // It's already open
      }
  
      toggleButton.setAttribute('aria-expanded', 'true');
      collapsibleInner.style.overflow = 'visible';
      collapsibleInner.style.height = 'auto';
  
      // Animate slide down effect
      collapsibleInner.style.display = 'block';
      collapsibleInner.style.transition = 'height 0.3s ease-out';
      collapsibleInner.style.height = collapsibleInner.scrollHeight + 'px';
  
      setTimeout(() => {
        collapsibleInner.style.height = 'auto'; // Reset height after animation
      }, 300);
    };
  
    /**
     * Close a given collapsible
     */
    Collapsible.prototype._close = function (collapsible) {
      var toggleButton = collapsible.querySelector('.Collapsible__Button');
      var collapsibleInner = collapsible.querySelector('.Collapsible__Inner');
  
      if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
        return; // It's already closed
      }
  
      toggleButton.setAttribute('aria-expanded', 'false');
      collapsibleInner.style.overflow = 'hidden';
  
      // Animate slide up effect
      collapsibleInner.style.height = collapsibleInner.scrollHeight + 'px'; // Set the height to the full height
      collapsibleInner.offsetHeight; // Force reflow
      collapsibleInner.style.transition = 'height 0.3s ease-in';
      collapsibleInner.style.height = '0';
  
      setTimeout(() => {
        collapsibleInner.style.display = 'none'; // Hide element after animation
      }, 300);
    };
  
    return Collapsible;
  })();

  var collapsible = new Collapsible();
  // Initialize toggleStores
  toggleStores();
  
  // Functionality for .mob-menu-sub-item-opner
  document.querySelectorAll('.mob-menu-sub-item-opner').forEach(function (element) {
    element.addEventListener('click', function () {
      var parentItem = this.closest('.mob-menu-single-item');
      var displayItem = parentItem.querySelector('.mob-menu-sub-item-display');
  
      if (displayItem) {
        displayItem.style.display = 'block';
        displayItem.style.transform = 'translate3d(0%, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)';
        displayItem.style.transformStyle = 'preserve-3d';
      }
    });
  });


  

  


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

jQuery(document).ready(function ($) {
  // Function to check if viewport width is less than 786px
  function checkViewport() {
    if ($(window).width() < 786) {
      // Hide the ul elements initially
      $('.footer__quicklinks').hide();

      // Add "+" sign to the CUSTOMER CARE title if not already added
      $('.footer__block__title').each(function() {
        if (!$(this).find('.toggle-icon').length) {
          $(this).append('<span class="toggle-icon"> +</span>');
        }
      });

      // Remove any previous click event handlers before adding new ones
      $('.footer__block__title').off('click');

      // Add click event to the h2 elements (CUSTOMER CARE)
      $('.footer__block__title').on('click', function () {
        var quicklinks = $(this).next('.footer__quicklinks');
        var icon = $(this).find('.toggle-icon');

        // Toggle the visibility of the ul list with slideToggle and change icon when complete
        quicklinks.slideToggle(300, function () {
          if (quicklinks.is(':visible')) {
            icon.text(' -');  // Show '-' when the list is visible (expanded)
          } else {
            icon.text(' +');  // Show '+' when the list is hidden (collapsed)
          }
        });
      });
    } else {
      // If viewport is more than 786px, ensure the ul is visible and reset title
      $('.footer__quicklinks').show();
      $('.footer__block__title .toggle-icon').remove();
      $('.footer__block__title').off('click');  // Remove click event when viewport is larger than 786px
    }
  }

  // Check on page load
  checkViewport();

  // Check on window resize
  $(window).resize(function () {
    checkViewport();
  });
});




// popup js start

document.addEventListener('DOMContentLoaded', function() {





   fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data => {
      const countryCode = data?.detected_values?.country?.handle; // Extract the country code

      const euCountries = [
        "AT", "BE", "GB", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "EU"
      ];

      if (euCountries.includes(countryCode)) {
        // User is from an EU country
        console.log("User is from an EU country: ", countryCode);
         //showDutiesAndTaxesBlock();

        const block = document.getElementById("duties-taxes-not-included");
        if (block) {
             block.classList.remove("hidden");  
        }
      } else {
        console.log("User is not from an EU country: ", countryCode);
       const dutiesTaxesElement = document.getElementById('duties-taxes-not-included');

        if (dutiesTaxesElement) {
          dutiesTaxesElement.remove();
          console.log("Removed element: div#duties-taxes-not-included");
        }

      }
    })
    .catch(error => {
      console.error('Error:', error);
      // Handle error if the request fails
    });
 });





 
var dutiesmodal = document.getElementById("dutiesModal");
var btn = document.getElementById("DutiesButton");
var span = document.getElementsByClassName("close")[0];

if (btn) {
  btn.onclick = function() {
    dutiesmodal.style.display = 'block';
    document.body.classList.add("duties-modal-open"); 
  }
}
if (span) {
  span.onclick = function() {
    dutiesmodal.style.display = 'none';
    document.body.classList.remove("duties-modal-open");
  }
}

window.onclick = function(event) {
  if (event.target == dutiesmodal) {
    dutiesmodal.style.display = 'none';
     document.body.classList.remove("duties-modal-open");
  }
}


// popup js end


// ============== Product Grid Media slider ==============
document.querySelectorAll('.product-media-slider').forEach(wrapper => {
  const slider = new Flickity(wrapper.querySelector('.product-link'), {
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    wrapAround: true,
    prevNextButtons: false
  });

  if (wrapper.querySelector('.flickity-prev')) {
    wrapper.querySelector('.flickity-prev').addEventListener('click', () => slider.previous());
  }
  if (wrapper.querySelector('.flickity-next')) {
    wrapper.querySelector('.flickity-next').addEventListener('click', () => slider.next());
  }
});


// ============== Product Grid Variants ==============
document.addEventListener("click", (event) => {
    const openButton = event.target.closest(".variant_open_button");
    if (openButton) {
        const popupWrapper = openButton.nextElementSibling;
        if (popupWrapper && popupWrapper.classList.contains("variant_popup_content_wrapper")) {
            popupWrapper.classList.add("active");
        }
    }
});

document.addEventListener("click", (event) => {
    const closeButton = event.target.closest(".popup_close_btn");
    if (closeButton) {
        const popupWrapper = closeButton.closest(".variant_popup_content_wrapper");
        if (popupWrapper) {
            popupWrapper.classList.remove("active");
        }
    }
});